import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { LOGO_URL, mainNav } from '../../data/site';
const isExternal = (href: string) => href.startsWith('http');
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    const onResize = () => window.innerWidth >= 1024 && setOpen(false);
    window.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
    };
  }, [open]);
  return <header className={`sticky top-0 z-50 bg-white/95 backdrop-blur transition-[box-shadow] duration-200 ease-out ${scrolled ? 'shadow-[0_1px_0_rgba(39,52,71,0.08),0_10px_30px_-18px_rgba(21,52,136,0.35)]' : ''}`} data-id="element-24" data-mp="3t0j6rffbqwa6">
      <div className="px-fluid flex h-[var(--header-h)] items-center justify-between gap-6" data-id="element-25" data-mp="3k164b6pmb7yy">
        <a href="#top" className="shrink-0" aria-label="David Moceri — back to top" data-id="element-26" data-mp="kjobom4rqg6n">
          <img src={LOGO_URL} alt="David Moceri" className="h-[clamp(2.1rem,1.6rem+1.2vw,3.5rem)] w-auto" width={300} height={80} data-id="element-27" data-mp="flczw5uwxvls" />
        </a>

        <nav aria-label="Main" className="hidden lg:block" data-id="element-28" data-mp="6s9oe33tvsts">
          <ul className="flex items-center gap-[clamp(1.25rem,2.2vw,3.5rem)]" data-id="element-29" data-mp="13ayz2tbacats">
            {mainNav.map(item => <li key={item.label} data-id="element-30" data-mp="yk8uhiaooc05">
                <a href={item.href} {...isExternal(item.href) ? {
              target: '_self'
            } : {}} className="whitespace-nowrap text-[clamp(0.95rem,0.8rem+0.3vw,1.3rem)] font-semibold text-brand-slate transition-colors duration-150 ease-out hover:text-brand-blue" data-id="element-31" data-mp="yixnzapusq5c">
                  {item.label}
                </a>
              </li>)}
            <li data-id="element-32" data-mp="2nzjixjl7f0rw">
              <a href="#contact" className="btn bg-brand-navy text-white hover:bg-brand-blue" data-id="element-33" data-mp="2a1uy2br4ztmu">
                Let’s Talk
              </a>
            </li>
          </ul>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-11 w-11 items-center justify-center rounded-full text-brand-navy transition-colors duration-150 hover:bg-brand-mist lg:hidden" data-id="element-34" data-mp="2eyv5or3mx4g2">
          {open ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-35" data-mp="3alzaga6raoy" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-36" data-mp="1nswha5jy2up2" />}
        </button>
      </div>

      <AnimatePresence data-id="element-37" data-mp="1iuv2hwtjxhje">
        {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full border-t border-brand-slate/10 bg-white shadow-[0_24px_40px_-24px_rgba(21,52,136,0.4)] lg:hidden" data-id="element-38" data-mp="1ivxte4qvjjzb">
            <ul className="px-fluid flex flex-col py-4" data-id="element-39" data-mp="2ghv4hh2xcn18">
              {mainNav.map(item => <li key={item.label} data-id="element-40" data-mp="2bja33ebxrxb7">
                  <a href={item.href} onClick={() => setOpen(false)} className="flex items-center justify-between border-b border-brand-slate/10 py-4 text-lg font-bold text-brand-slate hover:text-brand-blue" data-id="element-41" data-mp="2bkbrekhyqgav">
                    {item.label}
                    <ArrowRightIcon className="h-4 w-4 text-brand-blue" aria-hidden="true" data-id="element-42" data-mp="ilwqjlsotaqm" />
                  </a>
                </li>)}
              <li className="pt-5" data-id="element-43" data-mp="sjt0wbdsw1no">
                <a href="#contact" onClick={() => setOpen(false)} className="btn w-full bg-brand-navy text-white hover:bg-brand-blue" data-id="element-44" data-mp="skvpudrkbu0y">
                  Let’s Talk
                </a>
              </li>
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}